import lrModifytime from './_src/lrModifytime.vue'
lrModifytime.install = function(Vue) {
  Vue.component(lrModifytime.name, lrModifytime)
}

export default lrModifytime